/**
 * CalculatorFAQ — accordion with FAQ schema.org JSON-LD injected for SEO.
 */
import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function CalculatorFAQ({ faq }) {
    const [open, setOpen] = useState(0);
    if (!faq?.length) return null;

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faq.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
    };

    return (
        <section className="space-y-3" data-testid="calculator-faq">
            <h2 className="text-2xl font-bold text-bl">Frequently asked questions</h2>
            <div className="rounded-lg border border-bl/30 divide-y divide-bl/20">
                {faq.map((item, i) => (
                    <details
                        key={i}
                        open={open === i || undefined}
                        onToggle={(e) => e.target.open && setOpen(i)}
                        className="group"
                        data-testid={`faq-item-${i}`}
                    >
                        <summary className="cursor-pointer flex items-start justify-between gap-3 px-4 py-3 hover:bg-bl-bg list-none">
                            <span className="text-sm font-medium text-bl flex-1">{item.q}</span>
                            <ChevronDown className="h-4 w-4 text-bl-muted transition-transform group-open:rotate-180" />
                        </summary>
                        <div className="px-4 pb-4 text-sm text-bl-muted leading-relaxed">
                            {item.a}
                        </div>
                    </details>
                ))}
            </div>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
            />
        </section>
    );
}
